import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiDataUtils, JhiEventManager } from 'ng-jhipster';

import { FacultyService, Principal } from '../../../services';
import { Faculty } from '../../../models';
import { AlertUtils, FileUtils, ParamUtils, scrollToTop } from '../../../shared';
import { FACULTY_LIST_MODIFICATION } from '../../../shared/constants';
import { FileInputComponent } from '../../generic';

@Component({
    selector: 'qms-faculty-edit',
    templateUrl: './faculty-edit.component.html'
})
export class FacultyEditComponent implements OnInit {

    public facultyLogoMaxSize = Faculty.MAX_LOGO_SIZE_KB;
    public faculty: Faculty;
    public isSaving: boolean;

    private routeSubscription: Subscription;

    @ViewChild(FileInputComponent)
    private fileInput: FileInputComponent;

    constructor(private principal: Principal,
                private route: ActivatedRoute,
                private alertService: JhiAlertService,
                private dataUtils: JhiDataUtils,
                private eventManager: JhiEventManager,
                private facultyService: FacultyService) {
    }

    ngOnInit() {
        this.routeSubscription = this.route.params.subscribe((params) => {
            ParamUtils.parseNumber(params['id'], (facultyId: number) => {
                this.facultyService.find(facultyId).subscribe((faculty: Faculty) => {
                    this.faculty = faculty;
                }, () => {
                    this.cancel();
                });
            }, () => {
                AlertUtils.notifyNotFound(this.eventManager, this.alertService);
                this.cancel();
            });
        });
    }

    public save() {
        this.isSaving = true;
        this.facultyService.update(this.faculty).subscribe((response: Faculty) => {
            this.onUpdateSuccess(response);
        }, () => {
            this.isSaving = false;
            scrollToTop();
        });
    }

    public cancel() {
        window.history.back();
    }

    public setFileData(event) {
        FileUtils.validateImageSize(event, Faculty.MIM_LOGO_WIDTH, Faculty.MIM_LOGO_HEIGHT, () => {
            FileUtils.setFileData(event, this.dataUtils, (fileData: any, fileType: string) => {
                this.faculty.logo = fileData;
                this.faculty.logoContentType = fileType;
            });
        }, (errorMessage: string, params?: any) => {
            this.fileInput.clearFile();
            AlertUtils.notifyError(this.eventManager, this.alertService, errorMessage, params);
        });
    }

    public clearInputImage() {
        this.faculty.logoContentType = null;
        this.faculty.logo = null;
    }

    private onUpdateSuccess(result: Faculty) {
        AlertUtils.notifySuccess(this.eventManager, this.alertService,
            'faculty.updated', { param: result.name });

        this.eventManager.broadcast({ name: FACULTY_LIST_MODIFICATION, content: 'OK' });
        this.principal.identity(true); // Reload user after faculties modification
        this.isSaving = false;
        this.cancel();
    }

    public getLogo(faculty: Faculty) {
        return FileUtils.getImageBase64Format(faculty.logo, faculty.logoContentType);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/faculties/faculty-edit.component.ts